angular
	.module 'App.Repository'

.factory 'ConfigurationValueRepository',
	[
		'$rootScope', 'BaseRepository', 'UserInformation', 'BACKEND_CONFIGURATION_VALUE_ENTITY_TYPE', 'BACKEND_CONFIGURATION_ENTITY_TYPE',
		($rootScope, BaseRepository, UserInformation, BACKEND_CONFIGURATION_VALUE_ENTITY_TYPE, BACKEND_CONFIGURATION_ENTITY_TYPE) ->
			class ConfigurationValueRepository extends BaseRepository
				@resource = '/configuration_values'
				@isRestricted = true

				@type = ''
				@entityId = ''
				@context = ''

				saveByContext: (configuration, modelName, modelId) ->
					if modelName
						@setupContext modelName, modelId

					configurationValue = @convertConfigurationToConfigurationValue configuration

					if angular.isDefined configuration.file
						@saveWithAttachment configurationValue
					else
						@save configurationValue

				setupContext: (name, id = null) ->
					@entityId = id if id?

					switch(name)
						when 'users'
							@type = BACKEND_CONFIGURATION_VALUE_ENTITY_TYPE.USER
						when 'roles'
							@type = BACKEND_CONFIGURATION_VALUE_ENTITY_TYPE.ROLE
						when 'shops'
							@type = BACKEND_CONFIGURATION_VALUE_ENTITY_TYPE.SHOP
						when 'master_users'
							@type = BACKEND_CONFIGURATION_VALUE_ENTITY_TYPE.MASTER_USER
						else
							console.error 'Unknown model for configurations: ' + name + '. Valid models: user, role, shop'
							return

				convertConfigurationValueToConfiguration: (model, modelName, modelId) ->
					configuration = {}

					if modelName != null
						@setupContext modelName, modelId

					configuration.identifier = model.configuration_id
					configuration.id = model.id
					configuration.type = if @type then @type else model.type
					configuration.value = model.value

					return configuration

				convertConfigurationToConfigurationValue: (model) ->
					configurationValue =
						configuration_id: model.identifier
						value: model.value
						master_user_id: UserInformation.getMasterUser().id
						entity_type: @type
						owner_id: @entityId

					if angular.isDefined model.file
						configurationValue.file = model.file

					if angular.isDefined(model.id) && @type == model.type
						configurationValue.id = model.id

					configurationValue.values = _.map model.values, (item) -> {value: item}

					return configurationValue

				hideSensitiveInformation: (configuration) ->
					if configuration.value_type == BACKEND_CONFIGURATION_ENTITY_TYPE.ENCRYPTED_STRING
						configuration.is_set = not _.isEmpty configuration.value
						configuration.value = ''

			return new ConfigurationValueRepository
	]
